import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
}), 'Storage');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Storage.js
// module id = 6513
// module chunks = 2